var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('LocationSettings'),_c('hr'),_c('SchedulerSettings'),_c('hr'),_c('MemberManagement'),_c('hr'),_c('DeviceManagement')],1)}
var staticRenderFns = []

export { render, staticRenderFns }